// @ts-nocheck

import { Dialog, Form, useDialogContext, Button as AsioButton } from '@rich-products-corp/primitives-richproducts';
import { useToast } from '@rich-products-corp/react-ecomm-ui/dist';
import { AddressForm } from '@rich-products-corp/react-ecomm-ui/dist/components/PageSections/Ecommerce/forms/address';
import { addressFormSchema } from '@rich-products-corp/react-ecomm-ui/dist/components/PageSections/Ecommerce/forms/schemas/address.schema';
import { cn } from '@rich-products-corp/ui';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { genGenIDNumber } from './utils';
import { useAddAddress } from '@/hooks/my-account/address/use-add-address';
import useDeviceDetect from '@/hooks/useDeviceDetect';
import useScreenOrientation from '@/hooks/useOrientation';
import { useGoogleAutocomplete } from '@/hooks/useGoogleAutocomplete';
import { useAddressValidation } from '@/hooks/useAddressValidation';

const schema = yup
  .object()
  .shape({
    addressFormValues: addressFormSchema, //MONKEYPATCH: @Variaban - this is the only way to get this to work. Please check this before merging.
  })
  .required();

type AddressFormSchemaType = yup.InferType<typeof schema>;

export type CreateAddressDialogProps = {
  states: any[];
  onClose?: () => void;
};

export const CreateAddressDialog = ({ states, onClose, ...props }: CreateAddressDialogProps) => {
  const { validateAddress, DialogComponent } = useAddressValidation();
  const { mutateAsync: addAddress, isLoading: isAddAddressLoading } = useAddAddress();
  const [, { close }] = useDialogContext();

  const { isMobile } = useDeviceDetect();
  const orientation = useScreenOrientation();

  const { toast } = useToast();

  const form = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      addressFormValues: {},
    },
  });

  // Google Address Autocomplete.
  useGoogleAutocomplete({
      selector: 'input[name="addressFormValues.streetAddress"]',
      form,
  });

  const onSubmit = async (values: AddressFormSchemaType) => {
    const addressId = await genGenIDNumber('ADDRESS', toast);
    const { addressFormValues } = values;

    // ADDRESS VALIDATION START
    const isValid = await validateAddress([
    {
        addressSequence: 'ADD_1',
        firstName: addressFormValues.firstName,
        streetName: addressFormValues.streetAddress,
        postalCode: addressFormValues.zipCode,
        city: addressFormValues.city,
        state: addressFormValues.state,
        country: 'US',
        company: addressFormValues.company || '',
        phone: addressFormValues.phone || '',
        additionalAddressInfo: addressFormValues.apartment || '',
    }
    ]);

    if (!isValid) {
        return; // STOP if user clicked NO
    }
    // ADDRESS VALIDATION END

    const { company, streetAddress: streetName, zipCode: postalCode, apartment, ...formValues } = addressFormValues;

    const responseAddAddress = await addAddress({
      ...formValues,
      company,
      streetName,
      streetNumber: '',
      postalCode,
      country: 'US',
      additionalStreetInfo: apartment,
      city: addressFormValues.city,
      state: addressFormValues.state,
      firstName: addressFormValues.firstName,
      lastName: addressFormValues.lastName,
      key: addressId.toString() ?? undefined,
    });

    if (!responseAddAddress.isError) {
      if (onClose) onClose();
      close();
    }
  };

  return (
    <FormProvider {...form}>
      <Dialog {...props}>
        <Dialog.Content
            onInteractOutside={(e) => {
              const target = e.target as HTMLElement;

              if (target.closest('.pac-container')) {
                e.preventDefault();
                return;
              }
            }}
            className={cn(
            orientation === 'landscape-primary' && isMobile
                ? 'top-0 flex h-full flex-initial flex-col overflow-scroll'
                : 'h-full max-h-fit min-w-fit md:h-auto',
            )}
        >
          <Dialog.Header className="my-3 flex flex-row justify-center md:my-6">
            <Dialog.Title className="text-3xl leading-6">Add New Recipient/Address</Dialog.Title>
          </Dialog.Header>
          <Form
            onSubmit={form.handleSubmit(onSubmit)}
            actions={
              <nav className="flex flex-row justify-center">
                <AsioButton type="button" variant="link" onClick={close} className="mr-2 py-6">
                  Cancel
                </AsioButton>
                <AsioButton loading={isAddAddressLoading} type="submit" className="bg-gray-900 text-white">
                  {isAddAddressLoading ? 'submitting...' : 'SAVE CHANGES'}
                </AsioButton>
              </nav>
            }
          >
            <AddressForm form={form} schemaKey="addressFormValues" states={states} title="" />
          </Form>
          {/* ADD HERE */}
          <DialogComponent />
        </Dialog.Content>
      </Dialog>
    </FormProvider>
  );
};
